/**
 * đơn vị tính
 * tvanh 21.03.2024
 */
export default {
  None: 1,
  Quater: 2,
  Month: 3
};